import storage from 'redux-persist/lib/storage';
import { applyMiddleware, compose, createStore } from 'redux';
import { createFilter } from 'redux-persist-transform-filter';
import { persistReducer, persistStore } from 'redux-persist';
import { routerMiddleware } from 'connected-react-router';
import reducers from './reducers';
import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history';
import posthog from 'posthog-js';
import * as auth from 'redux/actions/auth';

export const history = createBrowserHistory();

const posthogMiddleware = (store) => (next) => (action) => {
  // need to run the reducer *first*
  const result = next(action);

  if (action.type === auth.GET_USER_INFO_SUCCESS) {
    const state = store.getState();
    const { user } = state.auth;

    posthog.identify(user.username);
  }

  return result;
};

const persistedFilter = createFilter('auth', ['token']);

const rootReducer = persistReducer(
  {
    key: 'polls',
    storage: storage,
    whitelist: ['auth'],
    transforms: [persistedFilter],
  },
  reducers(history),
);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
  rootReducer,
  {},
  composeEnhancers(
    applyMiddleware(thunk, posthogMiddleware, routerMiddleware(history)),
  ),
);

export const persistor = persistStore(store);
